import React from 'react'

import {
  Anchor,
  BarChart2,
  CheckSquare,
  Crosshair,
  Gift,
  Home,
  Package,
  Trello,
  Truck,
  Users,
} from 'react-feather'

interface RouteChild {
  path: string
  name: string
  icon?: JSX.Element
  badge?: string
  permissions?: string[]
}

export interface Route {
  id: string
  path: string
  icon: JSX.Element
  header?: string
  badge?: string
  containsHome: boolean
  open: boolean
  children?: RouteChild[] | null
  testOnly?: boolean
}

const homeRoute: Route = {
  id: 'Dashboards',
  path: '/',
  icon: <Trello />,
  containsHome: true,
  open: false,
  children: [
    {
      path: '/v2/dashboards/orders-shipments',
      name: 'Orders & Shipments',
    },
    {
      path: '/v2/dashboards/daily-ops',
      name: 'Daily Operations',
    },
  ],
}

const warehousingRoute: Route = {
  id: 'Warehouse',
  path: '/warehouse',
  icon: <Home />,
  containsHome: false,
  open: false,
  children: [
    {
      path: '/v2/warehouse/markets',
      name: 'Markets',
    },
    {
      path: '/v2/warehouse/facilities',
      name: 'Facilities',
    },
    {
      path: '/warehouse/places',
      name: 'Places',
    },
    {
      path: '/warehouse/containers',
      name: 'Containers',
    },
    {
      path: '/v2/warehouse/driver-visits',
      name: 'Driver Visits',
    },
  ],
}

const inventoryRoute: Route = {
  id: 'Inventory',
  path: '/inventory',
  icon: <Package />,
  containsHome: false,
  open: false,
  children: [
    {
      path: '/v2/inventory/products',
      name: 'Products',
    },
    {
      path: '/v2/inventory/skus',
      name: 'SKUs',
    },
    {
      path: '/inventory/sku-thresholds',
      name: 'SKU Threshold Alerts',
    },
    {
      path: '/inventory/batches',
      name: 'Batches',
    },
    {
      path: '/v2/inventory/pallets',
      name: 'Pallets',
    },
    {
      path: '/inventory/barcoded-units',
      name: 'Units (Barcoded)',
    },
    {
      path: '/v2/inventory/damages',
      name: 'Damages',
    },
    {
      path: '/inventory/audits',
      name: 'Audits',
    },
  ],
}

const lostAndFoundRoute: Route = {
  id: 'Lost & Found',
  path: '/inventory',
  icon: <Crosshair />,
  containsHome: false,
  open: false,
  children: [
    {
      path: '/inventory/lost',
      name: 'Lost',
    },
    {
      path: '/inventory/found',
      name: 'Found',
    },
  ],
}

const shippingRoute: Route = {
  id: 'Shipping',
  path: '/shipping',
  icon: <Anchor />,
  containsHome: false,
  open: false,
  children: [
    {
      path: '/shipping/carriers',
      name: 'Carriers',
    },
    {
      path: '/shipping/drivers',
      name: 'Drivers',
    },
    {
      path: '/v2/inbound/asns',
      name: 'Advanced Shipping Notices',
    },
  ],
}

const freightRoute: Route = {
  id: 'Freight',
  path: '/freight',
  icon: <Truck />,
  containsHome: false,
  open: false,
  children: [
    {
      path: '/v2/freight/orders',
      name: 'Orders',
    },
    {
      path: '/freight/replenishment',
      name: 'Replenishment',
    },
    {
      path: '/v2/freight/shipments',
      name: 'Shipments',
    },
    {
      path: '/v2/freight/truckloads',
      name: 'Truckloads',
    },
  ],
}

const parcelRoute: Route = {
  id: 'Parcel',
  path: '/v2/parcel',
  icon: <Gift />,
  containsHome: false,
  open: false,
  children: [
    {
      path: '/v2/parcel/orders',
      name: 'Orders',
    },
    {
      path: '/v2/parcel/shipments',
      name: 'Shipments',
    },
  ],
}

const workflowsRoute: Route = {
  id: 'Workflows',
  path: '/workflows',
  icon: <CheckSquare />,
  open: false,
  containsHome: false,
  children: [
    {
      path: '/v2/workflows/tasks',
      name: 'Tasks',
    },
    {
      path: '/v2/workflows/task-type-assignments',
      name: 'Task Type Assignment',
      permissions: ['tasks.manage'],
    },
  ],
}


const clientsRoute: Route = {
  id: 'Clients',
  path: '/v2/clients',
  icon: <Users />,
  containsHome: false,
  open: false,
  children: null,
}

const reportsRoute: Route = {
  id: 'Reports',
  path: '/v2/reports',
  icon: <BarChart2 />,
  containsHome: false,
  open: false,
  children: null,
  testOnly: true,
}

export const menu = [
  homeRoute,
  warehousingRoute,
  inventoryRoute,
  lostAndFoundRoute,
  clientsRoute,
  shippingRoute,
  freightRoute,
  parcelRoute,
  workflowsRoute,
  reportsRoute,
]
